import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import BenevolCheckLogo from '../components/BenevolCheckLogo';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      {/* Header */}
      <header className="container mx-auto px-4 py-6">
        <Link to="/" className="flex items-center gap-3">
          <BenevolCheckLogo size="sm" />
        </Link>
      </header>

      {/* Content */}
      <main className="container mx-auto px-4 py-8 max-w-3xl">
        <Card className="shadow-lg">
          <CardHeader>
            <CardTitle className="text-2xl text-indigo-900">Contact</CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            <div>
              <h3 className="font-semibold text-lg text-gray-800 mb-2">France Bénévolat Côte d'Or</h3>
              <div className="space-y-2 text-gray-600">
                <p>📍 Maison des Associations</p>
                <p>2 rue des Corroyeurs</p>
                <p>21000 Dijon</p>
              </div>
            </div>

            <div>
              <h3 className="font-semibold text-lg text-gray-800 mb-2">Nous contacter</h3>
              <div className="space-y-2 text-gray-600">
                <p>📧 Email : <a href="mailto:cotedor@francebenevolat.org" className="text-indigo-600 hover:underline">cotedor@francebenevolat.org</a></p>
                <p>📞 Téléphone : 03 80 74 38 11</p>
              </div>
            </div>

            <div>
              <h3 className="font-semibold text-lg text-gray-800 mb-2">Horaires d'ouverture</h3>
              <p className="text-gray-600">Du lundi au vendredi : 9h00 - 12h00 / 14h00 - 17h00</p>
            </div>

            <div>
              <h3 className="font-semibold text-lg text-gray-800 mb-2">Support technique</h3>
              <p className="text-gray-600">
                Pour toute question technique concernant l'utilisation de Bénévol'Check, 
                veuillez nous contacter par email à : <a href="mailto:benevolcheck@francebenevolat.org" className="text-indigo-600 hover:underline">benevolcheck@francebenevolat.org</a>
              </p>
            </div>

            <div className="pt-4">
              <Link to="/">
                <Button variant="outline">← Retour à l'accueil</Button>
              </Link>
            </div>
          </CardContent>
        </Card>
      </main>

      {/* Footer */}
      <footer className="bg-indigo-900 text-white mt-16 py-6">
        <div className="container mx-auto px-4 text-center">
          <p className="text-sm">&copy; 2025 Bénévol'Check - Propulsé par France Bénévolat avec l'aide du SDJES Côte d'Or</p>
        </div>
      </footer>
    </div>
  );
};

export default ContactPage;
